<template>
  <div class="currency-breakdown">
    <!-- Currency indicator button -->
    <v-btn
      v-if="breakdown && breakdown.length > 1"
      icon
      small
      color="info"
      class="currency-trigger-btn"
      @click="showModal = true"
    >
      <v-icon small>fal fa-ellipsis-v</v-icon>
    </v-btn>

    <!-- Currency Breakdown Modal -->
    <app-custom-dialog
      v-model="showModal"
      :footer="false"
      title="currency_breakdown"
    >
      <div slot="activator">
        <div v-if="!breakdown || breakdown.length === 0">
          <v-alert type="info" outlined class="mb-0">
            <v-icon left>fal fa-info-circle</v-icon>
            {{ $t("no_currency_breakdown_data_available") }}
          </v-alert>
        </div>

        <div v-else>
          <!-- Header with total summary -->
          <div class="currency-summary mb-4">
            <v-card outlined class="pa-3" elevation="0">
              <div class="d-flex align-center justify-space-between">
                <div class="text-subtitle-1 font-weight-medium text-primary">
                  <v-icon left small>fal fa-calculator</v-icon>
                  {{ $t("total_cost") }}
                </div>
                <v-chip color="success" outlined small>
                  {{ getTotalInLAK() | NumberFormat }}
                </v-chip>
              </div>
            </v-card>
          </div>

          <!-- Currency breakdown list -->
          <div class="currency-list">
            <div
              v-for="currency in breakdown"
              :key="currency.currency_code"
              class="currency-item mb-2"
              :class="getCurrencyItemClass(currency.currency_code)"
            >
              <v-card outlined class="pa-3" elevation="0">
                <div class="d-flex align-center justify-space-between">
                  <div class="currency-info d-flex align-center">
                    <div class="currency-flag mr-3">
                      <v-avatar size="28" class="currency-avatar">
                        <v-img
                          :src="getCurrencyFlag(currency.currency_code)"
                          :alt="currency.currency_name"
                        />
                      </v-avatar>
                    </div>

                    <div class="currency-details-text">
                      <div
                        class="currency-code text-subtitle-2 font-weight-bold"
                      >
                        {{ currency.currency_code }}
                      </div>
                      <div class="currency-name text-caption text-muted">
                        {{ currency.currency_name }}
                      </div>
                    </div>
                  </div>

                  <div class="currency-amounts text-right">
                    <div
                      class="original-amount text-subtitle-2 font-weight-bold text-primary"
                    >
                      {{ currency.currency_symbol
                      }}{{ currency.original_cost | NumberFormat }}
                    </div>
                    <div class="converted-amount text-caption text-muted">
                      ₭{{ currency.cost_in_lak | NumberFormat }}
                    </div>
                  </div>
                </div>
              </v-card>
            </div>
          </div>
        </div>
      </div>
    </app-custom-dialog>
  </div>
</template>

<script>
import { myMixin } from "@/mixin/main";
export default {
  name: "CurrencyBreakdown",
  mixins: [myMixin],
  props: {
    breakdown: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    getTotalInLAK() {
      if (!this.breakdown) return 0;
      return this.breakdown.reduce(
        (total, currency) => total + (currency.cost_in_lak || 0),
        0
      );
    },

    getCurrencyItemClass(currencyCode) {
      const baseClass = "currency-item";
      const currencyClasses = {
        LAK: "lak-currency",
        USD: "usd-currency",
        THB: "thb-currency",
        CNY: "cny-currency",
        EUR: "eur-currency",
      };
      return `${baseClass} ${currencyClasses[currencyCode] || ""}`;
    },

    getCurrencyFlag(currencyCode) {
      const flag = "https://devla.s3.ap-southeast-1.amazonaws.com/flags/";
      // You can replace these with actual flag URLs from your assets
      const flagMap = {
        LAK: flag + "lak.svg",
        USD: flag + "usd.svg",
        THB: flag + "thb.svg",
        CNY: flag + "cny.svg",
        EUR: flag + "eur.svg",
      };
      return flagMap[currencyCode] || flag + "ic_currency.svg";
    },
  },
};
</script>

<style scoped>
.currency-trigger-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
}

.currency-item {
  border-left: 3px solid #e0e0e0;
  transition: all 0.2s ease;
}

.currency-item.lak-currency {
  border-left-color: #4caf50;
}

.currency-item.usd-currency {
  border-left-color: #2196f3;
}

.currency-item.thb-currency {
  border-left-color: #ff9800;
}

.currency-item.cny-currency {
  border-left-color: #f44336;
}

.currency-item.eur-currency {
  border-left-color: #9c27b0;
}

.currency-avatar {
  border: 1px solid #e0e0e0;
}

.currency-details-text {
  min-width: 100px;
}

.currency-amounts {
  text-align: right;
  min-width: auto;
  width: 100%;
}

.currency-summary {
  background: #f8f9fa;
  border-radius: 8px;
}

.currency-item .v-card {
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
}

.currency-item .v-card:hover {
  border-color: #2196f3;
  box-shadow: 0 2px 8px rgba(33, 150, 243, 0.1);
}

.exchange-info {
  border-top: 1px solid #e9ecef;
  padding-top: 12px;
}
</style>
